import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React from 'react';
import Alert from '../../container/Alert';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import replaceID from '../../../utility/replaceID';
import steps from '../../../data/assesment-steps';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'assessment.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Free Assessment'
  },
  headerSubTitle: {
    id: 'assessment.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Upload files for translation free assessment.'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

const Runass = props => {
  const { intl } = props;
  //const fileList = project.files;

  return (
    <div className="preview page">
      <Helmet>
        <title>{intl.formatMessage(messages.htmlHeader)} - Shift</title>
      </Helmet>
      <Header
        title={intl.formatMessage(messages.headerTitle)}
        subtitle={intl.formatMessage(messages.headerSubTitle)}
        steps={replaceID(steps, '001')}
        selectedStep={1}
        icon="preview"
        locale={props.locale}
      />
      <Alert
        title={intl.formatMessage(messages.htmlHeader)}
        message={print(props.status)}
      />
      <div className="main">
        <div
          className="panel"
          style={{
            width: '60%',
            padding: '40px',
            boxSizing: 'content-box',
            marginTop: '15px',
            display: 'block',
            alignContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <table
            className="form"
            style={{ cellpadding: '10px', tableLayout: 'auto' }}
          >
            <tbody>
              <tr>
                <td style={{ width: '85%' }}>
                  <label>
                    5 files successfully loaded containing 4500 lines.
                  </label>
                </td>

                <td>
                  <span
                    className="button-container"
                    style={{ textAlign: 'center' }}
                  >
                    <button
                      className="button"
                      onClick={() => props.clickFAQHandler('1')}
                    >
                      <FormattedMessage
                        id="assessment.need.help.button.name"
                        defaultMessage="UpNeed Help ?"
                      />
                    </button>
                  </span>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>
                  <label>Would you like to proceed with assessment?</label>
                </td>
                <td />
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <span
                  className="button-container"
                  style={{
                    textAlign: 'left',
                    padding: '20px'
                  }}
                >
                  <button
                    className="button"
                    onClick={() => props.clickBackHandler()}
                  >
                    <FormattedMessage
                      id="run-assessment.back.button.name"
                      defaultMessage="Back"
                    />
                  </button>

                  <button
                    className="button"
                    style={{ marginLeft: '20px' }}
                    onClick={() => props.clickAssessHandler()}
                  >
                    <FormattedMessage
                      id="run-assessment.assess.button.name"
                      defaultMessage="Assess"
                    />
                  </button>
                </span>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

Runass.propTypes = {};

export default injectIntl(Runass);



// WEBPACK FOOTER //
// ./src/components/views/Runass/index.js